// extracted by mini-css-extract-plugin
module.exports = {"errors":"style_errors__2Wc8E","container":"style_container__auCjf","footerNav":"style_footerNav__2lthu"};